import PropTypes from "prop-types";
import React from "react";

import globalRules from "@swa-ui/core/assets/styles/globalRules.module.scss";
import i18n from "@swa-ui/locale";
import { classNames } from "@swa-ui/string";

export const RapidRewardsNumber = (props) => {
  const { className, isMember, accountNumber } = props;

  const accountNumberScreenReader = isMember
    ? "RapidRewardsNumber__RR_NUMBER__SCREEN_READER"
    : "RapidRewardsNumber__ACCOUNT_NUMBER__SCREEN_READER";
  const accountNumberText = isMember
    ? "RapidRewardsNumber__RR_NUMBER"
    : "RapidRewardsNumber__ACCOUNT_NUMBER";
  const accountNumberSpelled = accountNumber?.toString().split("").join(" ");

  return (
    <span className={getClassName()}>
      <span className={globalRules.hiddenFromScreen}>
        {i18n(accountNumberScreenReader, {
          accountNumber: accountNumberSpelled,
        })}
      </span>
      <span aria-hidden="true">
        {i18n(accountNumberText, {
          accountNumber: accountNumber,
        })}
      </span>
    </span>
  );

  function getClassName() {
    return classNames("accountNumber", className);
  }
};

export const rapidRewardsNumberPropTypes = {
  accountNumber: PropTypes.string,
  className: PropTypes.string,
  isMember: PropTypes.bool,
};

RapidRewardsNumber.propTypes = rapidRewardsNumberPropTypes;
